import { liveBind } from 'evite'
let { forEach } = Array.prototype;

class MobileAppPageView {

    constructor() {
        const $navs = document.querySelectorAll('.app-nav');
        const currentUrl = this.getParameterByName('app');
        const $body = document.querySelector('body');
        let left, right;

        const $currentLink = document.querySelectorAll(`.app-nav[data-id="${currentUrl}"]`);
        const $contentToDisplay = document.querySelectorAll(`.app-wrap[id="${currentUrl}"]`);

        if ($contentToDisplay.length) {
           left = $contentToDisplay[0].querySelector('.left');
           right = $contentToDisplay[0].querySelector('.right');
        }

        if (typeof window.is_mobile_site !== 'undefined' && window.is_mobile_site) {
            $body.classList.remove('side-menu-active');
        } else {
            $navs::forEach(el => el.classList.remove('selected'));
            if ($currentLink.length) $currentLink.classList.add('selected');
        }

        document.querySelectorAll('.app-wrap')::forEach(el => el.classList.add('closed'));
        $contentToDisplay::forEach(el => el.classList.remove('closed'));

        liveBind($body, 'swipeleft', '.mobile-marketing', function() {
            if (right) {
                window.location.href = right
            }
        });
        liveBind($body, 'swiperight', '.mobile-marketing', function() {
            if (left) {
                window.location.href = left
            }
        });
    };

    getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);

        if (!results || !results[2]) {
            return 'evite-app';
        }

        return decodeURIComponent(results[2].replace(/\+/g, " "));
    };
}

export default MobileAppPageView



// WEBPACK FOOTER //
// ./assets/es6/marketing/mobile_apps.es6